import type { QuoteDocument } from 'paintscout'

export function getContactAddress(contact: QuoteDocument['contact']) {
  if (!contact) {
    return ''
  }
  const address = contact.address || ''
  const city = contact.city || ''
  const postal = contact.postal || ''
  const province = contact.province || ''

  return {
    address,
    city,
    postal,
    province
  }
}
